export default __webpack_public_path__ + "static/media/blogger-logo-transparent-white.cc76a70a.png";